import { Button, Grid, IconButton, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import theme from "../../theme";
import useButtonStyles from "../../styles/useButtonStyles";

import SelectInputField from "../forms/formElements/SelectInputField";
import axios from "axios";
import { APIConstants } from "../../constants/ApiConstants";
import BasicModal from "../ui/BasicModal";
import Loader from "../ui/Loader";
import BasicAutoComplete from "../ui/BasicAutoComplete";
import { useAppSelector } from "../../redux/hooks";
import CloseIcon from "@mui/icons-material/Close";
import MultipleSelectInputField from "../forms/formElements/MultipleSelectInputField";
import { useNavigate } from "react-router-dom";
import {
  filterConstants,
  mobileConstraints,
  permissionsConstants
} from "../../constants/AppConstants";
import useActiveMerchants from "../../Hooks/merchant/useActiveMerchants";
export interface IAppProps {
  closeUpdateShopUserDetails?: Function;
  shopUser?: any;
  fetchShopUserList: Function;
}

export function UpdateShopUserDetails(props: IAppProps) {
  const navigate = useNavigate();
  const { closeUpdateShopUserDetails, shopUser, fetchShopUserList } = props;
  const [merchantState, setMerchantState] = useState({ merchant: "" });
  const [statusState, setStatusState] = useState({ status: "" });
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [apiSuccess, setApiSuccess] = useState(false);
  const [apiFailure, setApiFailure] = useState("Something Went Wrong");
  const [merchantLoading, setMerchantLoading] = useState(false);
  const [successMessageForShopUser, setSuccessMessageForShopUser] =
    useState("");

  const [merchantRoles, setMerchantRoles] = useState<string[]>([]);
  const [validationState, setValidationState] = useState({
    email: "",
  });
  const buttonStyles = useButtonStyles();

  const [formState, setFormState] = useState({
    email: shopUser?.email || "",
    first_name: shopUser?.firstName || "",
    last_name: shopUser?.lastName || "",
    mobile: shopUser?.mobileNumber !== "-" ? shopUser?.mobileNumber : "",
    user_role: shopUser?.role || "",
    designation: shopUser?.designation !== "-" ? shopUser?.designation : "",
  });
  const [visited, setVisited] = useState({
    email: false,
    first_name: false,
    last_name: false,
    mobile: false,
    merchant: false,
    status: false,
    user_role: false,
    designation: false,
  });

  const entireList = useAppSelector(
    (state: any) => state.persistReducers.getMerchantList.entireListOfMerchants
  );
  const filterMerchantList = useActiveMerchants();
  const merchantListFromRedux = filterMerchantList?.map((entity: any) => {
    return {
      id: entity.id,
      label: entity.name,
      external_id: entity.external_id,
    };
  });
  const selectedMerchant = merchantListFromRedux.find(
    (ele: any) => ele.label === merchantState.merchant
  )?.label;

  const merchantList = useAppSelector(
    (state: any) => state.persistReducers.getMerchantList.merchantList
  );
  const filterNewMerchantList = merchantList.filter(
    (merchant: any) => merchant.is_active === "1"
  );
  const lab = filterNewMerchantList.reduce((sub: any, item: any) => {
    if (!sub.includes(item.username)) {
      sub.push(item.username);
    }
    return sub;
  }, []);
  const UpdateShopUser = async () => {
    const newObje = merchantState?.merchant?.split(",");
    let merchant = "";
    let companyNamesSet = new Set<string>();
    let companyNamePayload = "";
    let externalId = "";

    try {
      if (newObje?.length > 1) {
        const extractedData = [];
        for (const merchantData of merchantList) {
          const merchantName = merchantData.merchant_name;
          if (newObje.includes(merchantName)) {
            const companyName =
              merchantData.companyName || merchantData.company_name;
            const external_id = merchantData.external_id;
            const extractedObject = {
              merchantName,
              companyName,
              external_id,
            };
            extractedData.push(extractedObject);
          }
        }

        for (const extractedObject of extractedData) {
          merchant += extractedObject?.merchantName + ",";
          companyNamesSet.add(extractedObject.companyName);
          externalId += extractedObject.external_id + ",";
        }
        let companyNamesArray: string[] = Array.from(companyNamesSet);
        companyNamePayload = companyNamesArray.join(",");

        merchant = merchant.slice(0, -1);
        externalId = externalId.slice(0, -1);
      } else {
        externalId = merchantListFromRedux.find(
          (ele: any) => ele.label === merchantState.merchant
        )?.external_id;

        const entry = entireList?.find(
          (entry: any) => entry.name === merchantState.merchant
        );

        companyNamePayload = entry?.custom_fields.field.find(
          (field: any) => field.name === "companyName"
        ).value;

        merchant = merchantState.merchant;
      }

      setLoading(true);

      const payload = {
        ...formState,
        ...statusState,
        ...merchantState,
        merchant,
        external_id: externalId,
        companyName: companyNamePayload,
        module: permissionsConstants.admin,
        feature: permissionsConstants.shop_user
      };
      const response = await axios.put(
        process.env.REACT_APP_API_URL + APIConstants.addShopUser,
        payload
      );

      setApiSuccess(true);
      setOpenModal(true);
      setSuccessMessageForShopUser(response.data.data);
      fetchShopUserList();
    } catch (error: any) {
      if (error?.response?.data?.message) {
        setApiFailure(error?.response?.data?.message);
      }
      console.error(error);
      setApiSuccess(false);
      setOpenModal(true);
    } finally {
      setLoading(false);
    }
  };

  const formValidate = () => {
    if (formState.first_name === "") return false;
    if (formState.last_name === "") return false;

    if (formState.email === "" || validationState.email !== "") return false;
    if (merchantState.merchant === "" || merchantState.merchant === "Select")
      return false;
    if (statusState.status === "" || statusState.status === "Select")
      return false;

    return true;
  };
  useEffect(() => {
    const fetchRoleList = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          process.env.REACT_APP_API_URL + APIConstants.role + "?type=Merchant"
        );
        const data = response.data.data;
        const roles = data.map((item: any) => {
          return item.name;
        });
        setMerchantRoles(roles);
        setLoading(false);
      } catch (error) {
        console.error(error);
        setLoading(false);
      }
    };

    fetchRoleList();
  }, []);
  const onCloseRed = () => {
    if (closeUpdateShopUserDetails) closeUpdateShopUserDetails(false);
    navigate("/admin");
  };
  const onCloseShopUser = () => {
    closeUpdateShopUserDetails && closeUpdateShopUserDetails(false);
  };
  return (
    <Grid display={"flex"} flexDirection={"column"} height={"100%"}>
      <Grid
        item
        width={"100%"}
        height={"6.25rem"}
        display={"flex"}
        alignItems={"center"}
        sx={{ background: theme.color?.background }}
      >
        <Grid
          item
          display={"flex"}
          alignItems={"center"}
          justifyContent={"space-between"}
          px={4}
          gap={2}
          width={"100%"}
        >
          <Typography
            variant="h6"
            sx={{
              fontFamily: theme.font?.fontFamily.primary,
              fontSize: theme.font?.fontSize.large,
              fontWeight: theme.font?.fontWeight.thick,
            }}
            pl={2}
          >
            Update Shop User
          </Typography>
          <IconButton aria-label="delete" onClick={onCloseRed}>
            <CloseIcon />
          </IconButton>
        </Grid>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: theme?.color?.background,
        }}
        width={"100%"}
        height={"100%"}
        display={"flex"}
        flexDirection={"column"}
        justifyContent={"space-between"}
      >
        <Grid pt={2} px={4} display={"flex"} flexDirection={"column"} gap={2}>
          <Grid display={"flex"} gap={2} width={"100%"}>
            <Grid item width={"50%"}>
              <Typography sx={{ fontFamily: theme.font?.fontFamily.primary }}>
                First Name *
              </Typography>
              <TextField
                type="text"
                fullWidth
                size="small"
                defaultValue={shopUser?.firstName || ""}
                value={formState.first_name}
                onFocus={(e) =>
                  setVisited((prev) => ({
                    ...prev,
                    first_name: true,
                  }))
                }
                onChange={(e) =>
                  setFormState((prev) => ({
                    ...prev,
                    first_name: e.target.value,
                  }))
                }
                error={visited.first_name && formState.first_name === ""}
                helperText={
                  visited.first_name && formState.first_name === ""
                    ? "Required field"
                    : ""
                }
              ></TextField>
            </Grid>
            <Grid item width={"50%"}>
              <Typography sx={{ fontFamily: theme.font?.fontFamily.primary }}>
                Last Name *
              </Typography>
              <TextField
                type="text"
                fullWidth
                size="small"
                defaultValue={shopUser?.lastName || ""}
                value={formState.last_name}
                onFocus={(e) =>
                  setVisited((prev) => ({
                    ...prev,
                    last_name: true,
                  }))
                }
                onChange={(e) =>
                  setFormState((prev) => ({
                    ...prev,
                    last_name: e.target.value,
                  }))
                }
                error={visited.last_name && formState.last_name === ""}
                helperText={
                  visited.last_name && formState.last_name === ""
                    ? "Required field"
                    : ""
                }
              ></TextField>
            </Grid>
          </Grid>
          <Grid display={"flex"} gap={2} width={"100%"}>
            <Grid item width={"50%"}>
              <Typography sx={{ fontFamily: theme.font?.fontFamily.primary }}>
                Email *
              </Typography>
              <TextField
                fullWidth
                type="email"
                size="small"
                defaultValue={shopUser?.email || ""}
                value={formState.email}
                disabled
                onFocus={(e) =>
                  setVisited((prev) => ({
                    ...prev,
                    email: true,
                  }))
                }
                onChange={(e) => {
                  const email = e.target.value;
                  setFormState((prev) => ({ ...prev, email }));
                  // Email validation using regex
                  const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
                  const isValidEmail = emailRegex.test(email);
                  setValidationState((prev) => ({
                    ...prev,
                    email: !isValidEmail ? "Invalid email address" : "",
                  }));
                }}
                error={
                  visited.email &&
                  (validationState.email !== "" || formState.email === "")
                }
                helperText={
                  visited.email && validationState.email !== ""
                    ? "Invalid email address"
                    : ""
                }
              ></TextField>
            </Grid>
            <Grid item width={"50%"}>
              <Typography sx={{ fontFamily: theme.font?.fontFamily.primary }}>
                Mobile Number
              </Typography>
              <TextField
                type="number"
                fullWidth
                size="small"
                defaultValue={shopUser?.mobileNumber || ""}
                value={formState.mobile}
                onChange={(e) =>
                  setFormState((prev) => ({ ...prev, mobile: e.target.value }))
                }
                error={
                  visited.mobile &&
                  formState.mobile.length < mobileConstraints.mobileMin &&
                  formState.mobile.length > mobileConstraints.mobileMax
                }
                helperText={
                  visited.mobile &&
                  (formState.mobile.length < mobileConstraints.mobileMin ||
                    formState.mobile.length > mobileConstraints.mobileMax)
                    ? "Invalid Number"
                    : ""
                }
                onFocus={(e) =>
                  setVisited((prev) => ({
                    ...prev,
                    mobile: true,
                  }))
                }
              ></TextField>
            </Grid>
          </Grid>

          <Grid display={"flex"} gap={2} width={"100%"}>
            <Grid item width={"50%"}>
              {formState.user_role === "Tenant Admin" ||
              formState.user_role === "Tenant Finance" ? (
                <MultipleSelectInputField
                  defaultValue={
                    shopUser?.merchant === "-" || shopUser?.merchant === ""
                      ? ""
                      : shopUser?.merchant
                  }
                  setState={setMerchantState}
                  stateKey="merchant"
                  label="Merchant *"
                  options={lab}
                  align="left"
                />
              ) : (
                <BasicAutoComplete
                  label={"Merchant *"}
                  setState={setMerchantState}
                  stateKey="merchant"
                  secondaryStateKey="merchantType"
                  defaultValue={
                    shopUser?.merchant === "-" || shopUser?.merchant === ""
                      ? ""
                      : shopUser?.merchant
                  }
                  options={merchantListFromRedux}
                  required={true}
                  loading={merchantLoading}
                  error={visited.merchant && !merchantState.merchant}
                  onFocus={(e: any) =>
                    setVisited((prev) => ({
                      ...prev,
                      merchant: true,
                    }))
                  }
                />
              )}
            </Grid>
            <Grid item width={"50%"}>
              <Typography sx={{ fontFamily: theme.font?.fontFamily.primary }}>
                Role *
              </Typography>
              <SelectInputField
                sx={{ width: "100%" }}
                setState={setFormState}
                stateKey="user_role"
                defaultValue={shopUser?.role || "Tenant Admin"}
                align="left"
                options={merchantRoles}
              />
            </Grid>
          </Grid>
          <Grid display={"flex"} gap={2} width={"100%"}>
            <Grid item width={"50%"}>
              <Typography sx={{ fontFamily: theme.font?.fontFamily.primary }}>
                Status *
              </Typography>
              <SelectInputField
                sx={{ width: "100%" }}
                setState={setStatusState}
                stateKey="status"
                defaultValue={shopUser?.status || "select"}
                align="left"
                options={[
                  filterConstants.Select,
                  filterConstants.Active,
                  filterConstants.Inactive,
                ]}
                error={
                  visited.status &&
                  (statusState?.status === "" ||
                    statusState?.status === "Select")
                }
                onFocus={(e) =>
                  setVisited((prev) => ({
                    ...prev,
                    status: true,
                  }))
                }
              />
            </Grid>
            <Grid item width={"50%"}>
              <Typography sx={{ fontFamily: theme.font?.fontFamily.primary }}>
                Designation
              </Typography>
              <TextField
                type="text"
                fullWidth
                size="small"
                defaultValue={
                  shopUser?.designation !== "-" ? shopUser?.designation : ""
                }
                value={formState.designation}
                onFocus={(e) =>
                  setVisited((prev) => ({
                    ...prev,
                    designation: true,
                  }))
                }
                onChange={(e) =>
                  setFormState((prev) => ({
                    ...prev,
                    designation: e.target.value,
                  }))
                }
              ></TextField>
            </Grid>
          </Grid>
          <Grid display={"flex"} gap={2}></Grid>
        </Grid>

        <Grid
          container
          item
          marginTop={4}
          justifyContent={"center"}
          borderTop={`${theme?.border?.xsmall}${theme.color?.dividerLight}`}
          padding={2}
          pt={3}
          pb={4}
          display={"flex"}
          gap={2}
        >
          <Button
            sx={{ ...buttonStyles.outlinedSecondary, width: "45%" }}
            variant="outlined"
            onClick={onCloseRed}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            sx={{ ...buttonStyles.containedSecondary, width: "45%" }}
            variant="contained"
            onClick={UpdateShopUser}
            disabled={!formValidate()}
          >
            Save
          </Button>
        </Grid>
        {openModal && (
          <BasicModal
            title={apiSuccess ? successMessageForShopUser : apiFailure}
            setState={setOpenModal}
            success={apiSuccess}
            redirection="/admin?tab=shopUser"
            onCloseModule={onCloseShopUser}
          />
        )}
        {loading && <BasicModal content={<Loader />} />}
      </Grid>
    </Grid>
  );
}
